module.exports = __webpack_public_path__ + "02b09d5278166580e1399ade6d07f20c.png";